import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Portions of this file are Copyright 2021 Google LLC, and licensed under GPL2+. See COPYING.
import React, { useEffect, useState } from 'react';
import { Model } from '../state/model';
import EditorPanel from './EditorPanel';
import ViewerPanel from './ViewerPanel';
import Footer from './Footer';
import { ModelContext, FSContext } from './contexts';
import PanelSwitcher from './PanelSwitcher';
import { ConfirmDialog } from 'primereact/confirmdialog';
import CustomizerPanel from './CustomizerPanel';
export function App({ initialState, statePersister, fs }) {
    const [state, setState] = useState(initialState);
    const model = new Model(fs, state, setState, statePersister);
    useEffect(() => model.init());
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'F5') {
                event.preventDefault();
                model.render({ isPreview: true, now: true });
            }
            else if (event.key === 'F6') {
                event.preventDefault();
                model.render({ isPreview: false, now: true });
            }
            else if (event.key === 'F7') {
                event.preventDefault();
                model.export();
            }
        };
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const zIndexOfPanelsDependingOnFocus = {
        editor: {
            editor: 3,
            viewer: 1,
            customizer: 0,
        },
        viewer: {
            editor: 2,
            viewer: 3,
            customizer: 1,
        },
        customizer: {
            editor: 0,
            viewer: 1,
            customizer: 3,
        }
    };
    const layout = state.view.layout;
    const mode = state.view.layout.mode;
    function getPanelStyle(id) {
        if (layout.mode === 'multi') {
            const itemCount = (layout.editor ? 1 : 0) + (layout.viewer ? 1 : 0) + (layout.customizer ? 1 : 0);
            return {
                flex: 1,
                maxWidth: Math.floor(100 / itemCount) + '%',
                display: state.view.layout[id] ? 'flex' : 'none'
            };
        }
        else {
            return {
                flex: 1,
                zIndex: Number(zIndexOfPanelsDependingOnFocus[id][layout.focus]),
            };
        }
    }
    return (_jsx(ModelContext.Provider, { value: model, children: _jsx(FSContext.Provider, { value: fs, children: _jsxs("div", { className: 'flex flex-column', style: {
                    flex: 1,
                }, children: [_jsx(PanelSwitcher, {}), _jsxs("div", { className: mode === 'multi' ? 'flex flex-row' : 'flex flex-column', style: mode === 'multi' ? { flex: 1 } : {
                            flex: 1,
                            position: 'relative'
                        }, children: [_jsx(EditorPanel, { className: `
              opacity-animated
              ${layout.mode === 'single' && layout.focus !== 'editor' ? 'opacity-0' : ''}
              ${layout.mode === 'single' ? 'absolute-fill' : ''}
            `, style: getPanelStyle('editor') }), _jsx(ViewerPanel, { className: layout.mode === 'single' ? `absolute-fill` : '', style: getPanelStyle('viewer') }), _jsx(CustomizerPanel, { className: `
              opacity-animated
              ${layout.mode === 'single' && layout.focus !== 'customizer' ? 'opacity-0' : ''}
              ${layout.mode === 'single' ? `absolute-fill` : ''}
            `, style: getPanelStyle('customizer') })] }), _jsx(Footer, {}), _jsx(ConfirmDialog, {})] }) }) }));
}
